import Vue from 'vue';
import {formatNumber} from '../helpers/number.helper';
import {inflection} from '../helpers/string.helper';
import {dateFormat} from '../helpers/date.helper';

/**
 * @return {void}
 */
export function registerVueFilters() {
    Vue.filter('currencySymbol', function (value) {
        return value + ' Kč';
    });

    Vue.filter('m2', function (value) {
        return value + ' m<sup>2</sup>';
    });

    Vue.filter('numberFormat', function (value) {
        if (!value) return ''
        return formatNumber(value);
    });

    Vue.filter('inflection', function (value, variants) {
        return inflection(parseFloat(value), variants);
    });

    Vue.filter('dateFormat', function (value, format = 'D. M. Y') {
        return dateFormat(value, format);
    });
}
